import { expValEquals } from '@confluence/feature-experiments';

export function getApolloRelayCacheBridgeDisabledReason(): string | null {
	if (!expValEquals('confluence_apollo_to_relay_migration', 'isEnabled', true)) {
		return 'apollo-to-relay-migration-disabled';
	}

	if (!expValEquals('confluence_apollo_relay_cache_bridge', 'isEnabled', true)) {
		return 'apollo-relay-cache-bridge-disabled';
	}

	return null;
}
